import { Roles } from "../enums";
import { RoleNames } from "./role-names";

export const RolesDropdownData = [
  // {
  //   value: Roles.SuperAdmin,
  //   label: RoleNames[Roles.SuperAdmin],
  // },
  // {
  //   value: Roles.Admin,
  //   label: RoleNames[Roles.Admin],
  // },
  {
    value: Roles.Partner,
    label: RoleNames[Roles.Partner],
  },
  {
    value: Roles.Manager,
    label: RoleNames[Roles.Manager],
  },
  {
    value: Roles.Cashier,
    label: RoleNames[Roles.Cashier],
  },
];